import { Flex, TextInput } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import DatePickerInput from "src/components/shared/_FormInputs/DatePickerInput";
import { useIsOnline } from "src/hooks";

import {
  StyledRemoveActionIcon,
  StyledYachtSetUpItem,
} from "../YachtSetUp.styled";

interface Props {
  id: string;
  remove: () => void;
}

const fields = [
  { name: "name", label: "Name" },
  { name: "loc", label: "Location" },
  { name: "no", label: "No" },
  { name: "type", label: "Type" },
  { name: "isc", label: "Initial System Charge (kg)" },
  { name: "lubg", label: "Lubricant Grade" },
  { name: "lubc", label: "Lubricant Charge (ltrs)" },
  { name: "man", label: "Manufacturer" },
  { name: "ref", label: "Refrigerant #" },
  { name: "sub", label: "Substance Name" },
  { name: "mass", label: "Mass (kg)" },
  { name: "date", label: "Date of Installation or Confirmation" },
];

const OzoneItem = ({ id, remove }: Props) => {
  const { register, control, setValue } = useFormContext();
  const isOnline = useIsOnline();

  const onDateChange = useCallback(
    (isoDate: string) => {
      setValue(`${id}.date`, isoDate);
    },
    [id, setValue],
  );

  const renderFields = useCallback(
    (start: number, end: number) =>
      fields
        .slice(start, end)
        .map(field => (
          <TextInput
            key={field.name}
            style={{ flex: 1 }}
            label={field.label}
            {...register(`${id}.${field.name}`)}
          />
        )),
    [id, register],
  );

  return (
    <StyledYachtSetUpItem style={{ width: "80%" }}>
      <Flex direction="column" w="100%" gap="md">
        <Flex w="100%" justify="space-between" gap="md">
          {renderFields(0, Math.floor(fields.length / 2))}
        </Flex>
        <Flex w="100%" justify="space-between" gap="md" align="flex-end">
          {renderFields(Math.floor(fields.length / 2), fields.length - 1)}
          <DatePickerInput
            label="Date of Installation or Confirmation"
            name={`${id}.defaultDate`}
            control={control}
            valueFormat="DD MMM YYYY"
            dropdownType="modal"
            style={{ flex: 1 }}
            additionalSetISODate={onDateChange}
          />
        </Flex>
      </Flex>
      {isOnline && (
        <StyledRemoveActionIcon onClick={remove} variant="outline" size={"sm"}>
          <IconX />
        </StyledRemoveActionIcon>
      )}
    </StyledYachtSetUpItem>
  );
};

export default OzoneItem;
